export const AUTH_TRY = 'AUTH_TRY';
export const AUTH_TRY_FROM_STORAGE = 'AUTH_TRY_FROM_STORAGE';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const APP_CONFIG = 'APP_CONFIG'
export const APP_CONFIG_SUCCESS = 'APP_CONFIG_SUCCESS';